<template>
  <div>
    <v-dialog v-model="show" persistent max-width="70%">
      <v-card>
        <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
          <v-toolbar-title class="subheading px-4">{{ $t("users.title") }}</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex px-4">
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    :label="$t('global.search')"
                    v-model="search_params.any"
                    @keydown="checkKeyPress"
                    autocomplete="new-password"
                    dark
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-app-bar>

        <v-divider></v-divider>

        <v-card-text class="py-0 mt-4">
          <v-data-table
            :headers="headers"
            :items="users"
            :items-per-page="users.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            item-key="id"
            :show-select="true"
            v-model="selected"
            :must-sort="true"
          >
            <template v-slot:item.unique_id="{ item }">
              {{ item.person.unique_id }}
            </template>

            <template v-slot:item.first_name="{ item }">
              {{ item.person.first_name }}
            </template>

            <template v-slot:item.last_name="{ item }">
              {{ item.person.last_name }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <action-button type="save" :text="$t('global.submit')" @click="submit" small :disabled="selected.length == 0" />
          <action-button type="cancel" @click="cancel" small />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "UserListPopup",

  props: {
    show: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      url: "",
      users: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["first_name"],
        sortDesc: [false]
      },
      search_params: {
        any: ""
      },

      selected: []
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.refresh = true
      }
    },
    show: {
      handler(val) {
        if (val) {
          this.selected = []
          this.users = []
          this.list()
        }
      }
    }
  },

  computed: {
    breakpointSmAndDown() {
      return this.$vuetify.breakpoint.smAndDown
    },
    headers: {
      get() {
        return [
          { text: this.$t("users.unique_id"), value: "unique_id" },
          { text: this.$t("users.first_name"), value: "first_name" },
          { text: this.$t("users.last_name"), value: "last_name" },
          { text: this.$t("users.email"), value: "email" }
        ]
      }
    }
  },

  methods: {
    list() {
      this.show_loading = true
      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios
        .get(this.API_URL + "users?" + query)
        .then((res) => {
          this.users = res.data.data
          this.total = res.data.meta.total
          this.refresh = false
          this.show_loading = false
          this.pagination.page = res.data.meta.current_page
          this.pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },

    filter(target) {
      this.refresh = true
      localStorage.setItem("__filter_User_List", JSON.stringify(this.search_params))
    },

    reset() {
      this.$refs.form.reset()
      this.refresh = true
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    },
    submit() {
      this.$emit(
        "callback_user_select",
        this.selected.map((a) => a.id)
      )
    },
    cancel() {
      this.$emit("callback_user_cancel")
    }
  }
}
</script>

<style>
thead.v-data-table-header-mobile tr th {
  padding: 0 !important;
}
</style>
